export const LiquidityNeeds = [
  { id: 'Not_important', name: 'Not important', code: 'not' },
  { id: 'Somewhat_important', name: 'Somewhat important', code: 'somewhat' },
  { id: 'Very_important', name: 'Very important', code: 'very' }
];
